document.addEventListener('DOMContentLoaded', function() {
    var carousels = document.querySelectorAll('.product-carousel');

    carousels.forEach(function(carousel) {
        var searchTerm = carousel.getAttribute('data-search-term');
        if (!searchTerm) {
            console.error('No search term found for carousel:', carousel.id);
            return;
        }

        var searchUrl = buildSearchUrl(searchTerm);
        if (!searchUrl) {
            console.error('Failed to build search URL for term:', searchTerm);
            return;
        }

        console.log('Fetching products for carousel:', carousel.id, 'from URL:', searchUrl);
        fetchProducts(searchUrl, carousel);
    });

    function buildSearchUrl(searchTerm) {
        return `https://api.fastsimon.com/full_text_search?q=${encodeURIComponent(searchTerm)}&page_num=1&UUID=9129a690-10b5-45b4-9c67-bca2461abb44&store_id=57381683374&cdn_cache_key=1717570154&src=v1&facets_required=1&callback=ispSearchResult&related_search=1&with_product_attributes=1`;
    }

    function fetchProducts(searchUrl, carousel) {
        fetch(searchUrl, { credentials: 'same-origin' })
        .then(response => {
            console.log('Received response from:', searchUrl);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.text();
        })
        .then(data => {
            console.log('Parsing JSONP response');
            var jsonpCallback = data.match(/ispSearchResult\((.+)\);/);
            if (!jsonpCallback) {
                throw new Error('Invalid JSONP response');
            }
            var jsonData = JSON.parse(jsonpCallback[1]);
            var products = jsonData.items.slice(0, 3);  // Get the first 3 products
            console.log('Found products:', products.length);
            if (products.length === 0) {
                console.error('No products found in the response.');
                console.log(data);  // Log the raw data for debugging
            }
            renderProducts(products, carousel);
        })
        .catch(error => console.error('Error fetching products:', error));
    }

    function renderProducts(products, carousel) {
        console.log('Rendering products for carousel:', carousel.id);
        carousel.innerHTML = '';  // Clear any existing content

        products.forEach(product => {
            var productLink = product.u;
            var productImage = product.t;
            var productName = product.l;
            var productSalePrice = product.p;
            var productRegularPrice = product.p_c;
            var productDescription = product.d;

            console.log('Product details - Name:', productName, 'Sale Price:', productSalePrice, 'Regular Price:', productRegularPrice, 'Link:', productLink);

            var shortDescription = getShortDescription(productDescription);
            var priceHTML = '';

            if (parseFloat(productSalePrice) < parseFloat(productRegularPrice)) {
                priceHTML = `<span style="color: red;">$${productSalePrice}</span> <span style="text-decoration: line-through;">$${productRegularPrice}</span>`;
            } else {
                priceHTML = `<span>$${productRegularPrice}</span>`;
            }

            var productHTML = `
                <div class="product-item" style="flex: 1; padding: 10px; box-sizing: border-box;">
                    <a href="${productLink}">
                        <img src="${productImage}" alt="${productName}" style="width: 100%;" />
                    </a>
                    <h2>${productName}</h2>
                    <p>${shortDescription} <a href="${productLink}">Read more</a></p>
                    <p>${priceHTML}</p>
                    <button data-product-url="${productLink}" class="add-to-cart">Add to Cart</button>
                </div>
            `;

            carousel.innerHTML += productHTML;
        });

        // Apply flexbox to display items in a row
        carousel.style.display = 'flex';
        carousel.style.justifyContent = 'space-between';

        // Initialize your carousel
        initializeCarousel(carousel);
    }

    function getShortDescription(description) {
        var sentences = description.split('. ');
        var twoSentences = sentences.slice(0, 2).join('. ') + '.';
        var words = description.split(' ');
        var twentyFiveWords = words.slice(0, 25).join(' ');
        return (twentyFiveWords.length < twoSentences.length) ? twentyFiveWords + '...' : twoSentences;
    }

    function initializeCarousel(carousel) {
        console.log('Initializing carousel for:', carousel.id);

        var items = carousel.querySelectorAll('.product-item');
        var currentIndex = 0;

        function showItem(index) {
            items.forEach((item, i) => {
                item.style.display = (i >= index && i < index + 3) ? 'block' : 'none';
            });
        }

        showItem(currentIndex);

        var prevButton = document.createElement('button');
        prevButton.textContent = 'Previous';
        prevButton.className = 'carousel-prev';
        prevButton.onclick = function() {
            currentIndex = (currentIndex === 0) ? items.length - 1 : currentIndex - 1;
            items[currentIndex].parentNode.insertBefore(items[currentIndex], items[0]);
            showItem(0);
        };

        var nextButton = document.createElement('button');
        nextButton.textContent = 'Next';
        nextButton.className = 'carousel-next';
        nextButton.onclick = function() {
            currentIndex = (currentIndex === items.length - 1) ? 0 : currentIndex + 1;
            items[currentIndex].parentNode.appendChild(items[currentIndex]);
            showItem(0);
        };

        carousel.appendChild(prevButton);
        carousel.appendChild(nextButton);
    }

    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('add-to-cart')) {
            var productUrl = event.target.getAttribute('data-product-url');
            console.log('Add to Cart clicked for product URL:', productUrl);
            addToCart(productUrl);
        }
    });

    function addToCart(productUrl) {
        // Logic to add product to cart, may require AJAX request or redirect
        console.log('Adding product to cart:', productUrl);
        alert('Add to cart functionality needs to be implemented.');
    }
});
